import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Tailwind only provides the animate-spin animation, so the spinner itself
// is a small inline SVG that follows the current text color.

Spinner.propTypes = {
  className: PropTypes.string
};

export default function Spinner(props) {
  const { className } = props;

  return (
    <svg
      className={classNames('animate-spin h-4 w-4', className)}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
    >
      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z" />
    </svg>
  );
}
